<div class="dialog-container">
  <div class="dialog-icon mb-2">
    <div class="dot-spinner" [ngStyle]="{'--uib-color': isLoader ? 'black':'var(--textColor)'}">
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
        <div class="dot-spinner__dot"></div>
    </div>
  </div>
  <div
    class="dialog-tittle text-capitalize"
    [ngClass]="{'white-text': !isLoader, 'dark-text': isLoader}"
  >
    {{ title }}...
  </div>
  <div
    class="dialog-subtitle"
    [ngClass]="{'white-text': !isLoader, 'dark-text': isLoader}"
  >
    {{ text }}
  </div>
</div>
